module.exports = __webpack_public_path__ + "media/images/file-icons/128/008-archive-1048e18acd7e3d8f52be2f184608da32.png";